import { render } from "./TypeOfBusiness.vue?vue&type=template&id=592b0d36"
import script from "./TypeOfBusiness.vue?vue&type=script&lang=js"
export * from "./TypeOfBusiness.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__